var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MglGeojsonLayer',{attrs:{"source-id":_vm.source.id,"source":_vm.source.json,"layer-id":_vm.layer.id,"layer":_vm.layer.json},on:{"click":_vm.onClick,"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}})}
var staticRenderFns = []

export { render, staticRenderFns }